import { SamdAppRepository } from '@samd/api/app_repository';
import { GraphqlClient } from 'src/api/graphql_client';
import {
  BuildVersionsQuery,
  BuildVersionsDocument,
  BuildVersionsFieldsFragment,
  EffectiveOrganizationDocument,
  EffectiveOrganizationQuery,
  OrganizationFieldsFragment,
} from 'src/types';

/**
 * Implementation of the App Repository for the Samd platform on a GraphQL backend.
 */
export class SamdGraphqlAppRepository implements SamdAppRepository {
  constructor(private readonly _graphqlClient: GraphqlClient) {}

  async getEffectiveOrganization(): Promise<OrganizationFieldsFragment> {
    const response =
      await this._graphqlClient.request<EffectiveOrganizationQuery>(
        EffectiveOrganizationDocument,
      );

    return response.auth0.effectiveOrganization;
  }

  async fetchBuildVersions(): Promise<BuildVersionsFieldsFragment> {
    const data = await this._graphqlClient.request<BuildVersionsQuery>(
      BuildVersionsDocument,
    );
    return data.buildVersions;
  }
}
